import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 19.75C13.4701 19.75 15.279 19.0594 16.6977 17.9071C17.9412 18.8296 19.2588 19.644 20.6399 20.3372C21.0101 20.523 21.4608 20.3736 21.6466 20.0034C21.8325 19.6332 21.683 19.1825 21.3128 18.9966C20.0821 18.3789 18.9033 17.6582 17.785 16.8446C19.0104 15.4049 19.75 13.5388 19.75 11.5C19.75 6.94365 16.0563 3.25 11.5 3.25C11.4735 3.25 11.4471 3.25012 11.4207 3.25037C11.4055 3.25012 11.3903 3.25 11.375 3.25H6C4.48122 3.25 3.25 4.48122 3.25 6V11.375C3.25 11.3903 3.25012 11.4055 3.25037 11.4207C3.25012 11.4471 3.25 11.4735 3.25 11.5C3.25 16.0563 6.94365 19.75 11.5 19.75ZM12.3615 11.3157C13.799 13.3392 15.6296 14.9673 17.5 16.5L16.5 17.5C14.5892 15.9097 12.609 14.2542 11.1386 12.1844C10.8987 11.8467 10.978 11.3785 11.3157 11.1386C11.6534 10.8987 12.1216 10.978 12.3615 11.3157Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
